import React from "react";
import { Field, reduxForm } from "redux-form";
import Button from "components/atoms/button/index.jsx";
import FormFieldset from "components/molecules/formFieldset/index.jsx";
import FormCol from "components/molecules/formCol/index.jsx";
import FormTextField from "components/molecules/formTextField/index.jsx";
import FormActions from "components/molecules/formActions/index.jsx";
import validate from "components/organisms/buyForm/validate.jsx";

class ContactInformationForm extends React.Component {
  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <h3>Datos de contacto</h3>
        <FormFieldset>
          <FormCol first="true">
            <Field
              name="telephone"
              type="text"
              component={FormTextField}
              label="Teléfono fijo"
            />

            <Field
              name="email"
              type="email"
              component={FormTextField}
              label="Correo electrónico"
            />
          </FormCol>
          <FormCol last="true">
            <Field
              name="cellphone"
              type="text"
              component={FormTextField}
              label="Teléfono celular"
            />

            <Field
              name="address"
              type="text"
              component={FormTextField}
              label="Domicilio"
            />
          </FormCol>
        </FormFieldset>

        <FormActions>
          <Button buttonText="Continuar" type="submit" />
        </FormActions>
      </form>
    );
  }
}

export default reduxForm({
  form: "buy",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(ContactInformationForm);
